import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { SystemAnnouncementsWidgetStore } from './system-annoucements-widget.store';
import { TranslationPipe } from '@raptor-fe/services';
import { SystemAnnouncement } from '@raptor-fe/core';
import { SystemAnnouncementDetailsModalComponent } from '../modals/system-announcement-details-modal/system-announcement-details-modal.component';

@Component({
    selector: 'lib-system-announcements-widget',
    imports: [TranslationPipe],
    templateUrl: './system-announcements-widget.component.html',
    providers: [SystemAnnouncementsWidgetStore],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemAnnouncementsWidgetComponent {
    protected readonly store = inject(SystemAnnouncementsWidgetStore);
    private readonly dialogService = inject(DialogService);

    protected openDetails(announcement: SystemAnnouncement): void {
        const dialogRef = this.dialogService.open({
            content: SystemAnnouncementDetailsModalComponent,
            width: '600px',
        });

        dialogRef.content.instance.announcement = signal(announcement);
    }
}
